// FILE: _chat.pull-requests.tsx
// Purpose: Registers the Pull Requests section under the shared chat shell, with its filters
//          parsed off the URL.
// Layer: Route
// Exports: Route

import { createFileRoute } from "@tanstack/react-router";
import { PullRequestsView } from "~/components/pullRequests/PullRequestsView";
import { parsePullRequestsRouteSearch } from "~/lib/pullRequestsRouteSearch";

export const Route = createFileRoute("/_chat/pull-requests")({
  // Never throws: an unreadable filter falls back to the default view rather than to an error
  // page, because a link somebody edited by hand should still show a list.
  validateSearch: (search) => parsePullRequestsRouteSearch(search),
  component: PullRequestsView,
});
